module.exports = __webpack_public_path__ + "img/6c479645f050b5413aff5513b6f356aa.png";